import { DTO } from "./dto.js";

export class LoginDTO extends DTO {
    constructor() {
        super();
        this.token = "";
    }

    cargarDTO(dto) {
        super.cargarDTO(dto);

        if (dto.token !== undefined) { this.token = dto.token; }
    }

    clone(dto) {
        super.clone(dto);

        dto.token = this.token;
    }
}
